<template>
  <div class="event bg-white FoundersGrotesk">
    <section class="container-xl">
      <div v-for="(rowData, index) in dataRows" :key="index" class="h-100">
        <b-row class="">
          <b-col class="m-0 p-0" cols="12" md="6">
            <div class="lg-text text-uppercase">THE ROOF</div>
          </b-col>

          <b-col cols="12" md="6" class="m-0 p-0">
            <div
              v-html="formatText(rowData.text)"
              class="md-text fade-in-up-element pb-4"
            ></div>

            <div class="d-flex justify-content-between">
              <div
                v-html="formatText(rowData.ContactText)"
                class="roof-header-text"
              ></div>
              <div>
                <a :href="rowData.link" target="_blank" class="email-link">{{
                  rowData.LinkText
                }}</a>
              </div>
            </div>

            <div>
              <a
                :href="rowData.FormLink"
                target="_blank"
                class="roof-header-text"
                >{{ rowData.BookText }}</a
              >
            </div>

            <div>
              <a
                :href="rowData.DeckLink"
                target="_blank"
                class="roof-header-text"
                >{{ rowData.EventDeck }}</a
              >
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data() {
    return {
      settings: {
        arrows: true,
        dots: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      dataRows: [
        {
          text: "Featuring two floors, massive colourful murals and sunset views of the city, Ode’s rooftop is one of the most memorable places to host your special event (if we do say so ourselves). \n\n Add a DJ, a cocktail fountain and some bomb food and you’ve got yourself a party goin’! Perfect for weddings, cocktail parties, rehearsal dinners, drag brunches, divorce parties, political rallies, team building events, corporate activations and more!",
          link: "mailto:hello@odetoronto.ca?subject=Book%20The%20Roof",
          LinkText: "HELLO@ODETORONTO.CA",
          ContactText: "SPECIAL EVENTS",
          BookText: "BOOK THE ROOF",
          FormLink: "https://forms.gle/hNgxZQhBnJW8FzhSA",
          EventDeck: "DOWNLOAD EVENT DECK",
          DeckLink: "/files/Ode_EventDeck.pdf",
        },
      ],
      slickImages: [
        {
          url: "/img/rooms/Deck-1.jpg",
        },
        {
          url: "/img/rooms/Deck-2.jpg",
        },
        {
          url: "/img/rooms/Deck-3.jpg",
        },
        {
          url: "/img/rooms/DeckGlass2.jpg",
        },
        {
          url: "/img/rooms/DeckMuralCloseUp.jpg",
        },
        {
          url: "/img/rooms/Deck-4.jpg",
        },
        {
          url: "/img/rooms/Deck-5.jpg",
        },
      ],
    };
  },
  components: { VueSlickCarousel },

  methods: {
    formatText(text) {
      return text.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/variables";
.event {
  padding: 50px 50px 60px 50px;
  @media screen and (max-width: 1176px) {
    padding: 40px 40px 60px 40px;
  }
  .link-text {
    letter-spacing: 1px;
  }
  .roof-header-text {
    font-size: 18px;
    font-weight: 600;
    line-height: 18px;
    @media screen and (max-width: 600px) {
      font-size: 15px;
    }
  }
  .email-link a:link,
  .email-link a:visited,
  .email-link a:hover,
  .email-link a:active {
    color: $m-black;
    text-decoration: underline;
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: $m-black;
    text-decoration: none;
  }

  .slider-container {
    position: relative;
  }
  .slider-container img {
    max-height: 500px;
    border: 2px solid $m-black;
  }

  .outer-container {
    width: 79%;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }

  img {
    width: 880px;
  }

  .image-container {
    position: relative;
    text-align: center;
  }

  .image-title {
    background-color: rgba(254, 255, 101, 0.8);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px 20px;
    font-size: 30px;
    @media screen and (max-width: 600px) {
      font-size: 15px;
    }
  }
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables";
.roof {
  .outer-container {
    .slick-prev.slick-arrow {
      width: 50px;
      height: 50px;
    }
    .slick-prev:before {
      content: "";
      display: inline-block;
      width: 55px;
      height: 55px;
      background-image: url("/img/back.svg");
      background-position: center;
      background-repeat: no-repeat;
      @media screen and (max-width: 600px) {
        width: 40px;
        height: 40px;
      }
    }
    .slick-prev {
      position: absolute;
      left: -70px;
      @media screen and (max-width: 600px) {
        left: -50px;
      }
    }
    .slick-next {
      position: absolute;
      right: -35px;
      @media screen and (max-width: 600px) {
        right: -25px;
      }
    }
    .slick-next:before {
      content: "";
      display: inline-block;
      width: 55px;
      height: 55px;
      background-image: url("/img/forward.svg");
      background-position: center;
      background-repeat: no-repeat;
      @media screen and (max-width: 600px) {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
